module.exports = __webpack_public_path__ + "img/fond-zebre@2x.635316f5.jpg";